import * as jsxRuntime from "/Users/elanyuan/Documents/sitecode/pctest/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment